'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";
import { type PageContentBoxProps } from "@/src/_types/Page/page-props";

const PageContentBox = styled(Box)<PageContentBoxProps>(({ theme, noBackground }) => ({
    position: 'relative',
    border: noBackground ? 'none' : `1px solid ${theme.palette.custom?.paperBorderColor}`,
    borderRadius: '-25px 0 25px rgba(51,51,51,0.025)',
    boxShadow: 'none',
    background: noBackground ? 'none' : theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: '1rem',
    ' img': {
        position: 'relative',
        maxWidth: '100%',
    },
    'h1, h2, h3, h4, h5, h6': {
        color: theme.palette.primary.main,
        marginBlockStart: 0,
        marginBlockEnd: '.5rem',
        textAlign: 'left',
        fontWeight: '100',
        [theme.breakpoints.between('xs', 'md')]: {
            fontSize: '1rem',
        },
    },
    '.alert': {
        position: 'relative',
        padding: '1rem',
        marginBottom: '1rem',
        border: `1px solid ${theme.palette.custom?.alertBorderColor}`,
        borderRadius: '.25rem',
    },
    '.alert-primary': {
        color: '#084298',
        backgroundColor: '#cfe2ff',
        borderColor: '#b6d4fe',
    },
    '& a': {
        color: theme.palette.custom?.link,
        transition: 'all ease-in-out .2s',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
            color: theme.palette.custom?.hoverLink,
            cursor: 'pointer',
        }
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        zIndex: '-1 !important',
        left: '4px',
        top: '5px',
        width: '5px',
        height: '6rem',
        boxShadow: `-5px 0 10px rgba(51,51,51,0.5)`,
        transform: 'rotate(-5deg)'
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        zIndex: '-1 !important',
        left: '0',
        top: '5px',
        width: '6rem',
        height: '5px',
        boxShadow: `-5px 0 10px rgba(51,51,51,0.5)`,
        transform: 'rotate(4deg)'
    },
    '& iframe': {
        border: 'none'
    },
    [theme.breakpoints.between('xs', 'md')]: {
        fontSize: '.9rem',
    },
    [theme.breakpoints.down('md')]: {
        paddingTop: '1rem',
        paddingRight: '1rem',
        paddingLeft: '1rem',
    },
    [theme.breakpoints.between('md', 'lg')]: {
        paddingTop: '1rem',
        paddingRight: '1rem',
        paddingLeft: '1rem',
    },
}));

export default PageContentBox;
